import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const tracingCustomStatusesAdapter = getAdapter({  idFieldName:'value'});

const tracingCustomStatusesSlice = createSlice({
    name: 'tracingCustomStatuses',
    initialState: tracingCustomStatusesAdapter.getInitialState(),
    reducers: {
        setTracingCustomStatuses: (state, { payload: { tracingCustomStatuses } }) => {
            tracingCustomStatusesAdapter.setAll(state, tracingCustomStatuses);
        },
    },
});

const selectors = tracingCustomStatusesAdapter.getSelectors(({ tracingCustomStatuses }) => tracingCustomStatuses);

export const getTracingCustomStatuses = (state) => selectors.selectAll(state);

export const {
    setTracingCustomStatuses,
} = tracingCustomStatusesSlice.actions;

export default tracingCustomStatusesSlice.reducer;
